import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { Product, AddToCartResponse } from 'src/app/models/product';
import { CartService } from 'src/app/services/cart.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProductItemComponent implements OnInit {

  @Input() Product: Product;
  @Input() Quantity = 0;
  @Output() OnAddToCartSuccess: EventEmitter<AddToCartResponse> = new EventEmitter();

  constructor(private cartService: CartService, private router: Router) { }

  ngOnInit() {
  }

  public updateQuantity(type: boolean): void {
    if (type) {
      this.Quantity += 1;
    } else {
      if (this.Quantity > 1) {
        this.Quantity -= 1;
      }
    }
  }

  public addToCart(): void {
    this.cartService.addToCart(this.Product.code, this.Product.unit_of_measure, this.Quantity, this.Product.product_category,
      (data) => {
        const addToCartResponse = {
          isSuccess: true,
          message: 'Success',
          product: this.Product
        };

        this.OnAddToCartSuccess.emit(addToCartResponse);
      },
      (err) => {
        const addToCartResponse = {
          isSuccess: false,
          message: err,
          product: this.Product
        };

        this.OnAddToCartSuccess.emit(addToCartResponse);
      });
  }
}
